// lib/utils.ts
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const truncate = (
  str: string,
  options: {
    length: number;
    omission?: string;
    separator?: string;
  }
): string => {
  const { length, omission = "...", separator = " " } = options;

  if (str.length <= length) return str;

  const truncated = str.slice(0, length + 1);
  const index = truncated.lastIndexOf(separator);

  return index === -1
    ? truncated + omission
    : truncated.slice(0, index) + omission;
};
